import {DynamicCrudService, OggettoConfig} from "../../../app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {RuoliAccesso} from "./SanPellegrino";
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {randomString} from "../../Utility/Utility";

export function Agenti():OggettoConfig{
  return {
    Id:"agenti",
    RestRoute: "/anagrafica/persone/agenti",
    fullListRoute:"/anagrafica/profilo/persona",
    HasAddList:{},
    ListResponseHasData:false,
    ListMap:(aa)=>{
      return aa.agenti;
    },
    Headers:[
      {...CampoAggiuntivo.TextField("Nominativo", "fullName", 'col-lg-12'), modificabile:false},
      CampoAggiuntivo.InputField("E-mail", "email", "email", "col-lg-12", {modificabile:false}),
    ],
    campi:[
      CampoAggiuntivo.TextField("Nome", "nome"),
      CampoAggiuntivo.TextField("Cognome", "cognome"),
      CampoAggiuntivo.InputField("E-mail", "email", "email")
    ],
    AzioniLista:[
      {
        nome: 'Genera Credenziali',
        close: false,
        icon: 'fas fa-key text-success',
        class: ' btn ',
        labelClass: 'text-success ',
        type: 'func',
        tooltip: "Gernera Credenziali",
        func:(field:any, api:ApiPathsService, onEnd: ()=>void, Toastr:ToastrService)=>{
         if(!field.email){
           Toastr.error("Indicare l'Email dell'utente");
           return;
         }
          saveRef(MapAgente(field,true), api, ()=>{
            api.ClassicPost('/anagrafica/persone/agenti/email', {ids: [field.id]}).subscribe(()=>{
              Toastr.success("Email Inviata con successo!");
              if(onEnd)
              onEnd()
            })
          },Toastr);
        },
      },
    ],
    ListDefaultFilter:{id: JSON.parse(localStorage.getItem("currentUser"))?.id},
    OnSaveMap:(x, api, bup, component: DynamicCrudService)=>MapAgente(x,false,component.authSvc.currentUserValue.id),
    MenuItems:[]
  }
}

function  MapAgente (agente, createAccount:boolean, idDm?:number){
  return  {
    ...agente,
    dm: idDm ?? agente.dm,
    principale: false,
    ruoliAccesso: RuoliAccesso("Agente"),
    ruoli:["AG"],
    username: agente.email,
    password: createAccount ? randomString(10) : null
  };
}

function saveRef(field,api: ApiPathsService,onEnd:()=>void,Toastr:ToastrService){

  api.ClassicPost(`/anagrafica/persone/agenti/${field.id ? 'update':'add'}`, field).subscribe(data=>{
    if(onEnd)
      onEnd();
  })
}
